import React, { Component } from 'react';



class Tutorial extends Component {

 

  render() {
    return (
      <div className="container-fluid text-center overflow-auto">
          <h1 > Quick Tutorial</h1>
          <p className=" display-4"> Not a mobile app!</p>
          <div className="card-body">
                      <p className="display-6">
                        PatternPath is an online editor web application for low-pattern developed with React and React-Konva.
                        Original my idea was that it can be apply by printing on any type of material, but at this stage the download image is less than 150
                        in dpi. So we don't advise you to print it on large format. While we are working to bring the dpi to 300 we are open to any possible collaboration.
                        So use it mostly for online purpose or small printing and don't forget to share the result with us.PatternPath is design at this point to be use on desktop,
                         you can still use it on mobile but without a good experience.
                      </p>

          </div>
          <h6>For a fast design process, this is our recommanded path</h6>
                      <span className="badge medium p-2 bg-dark text-white"><i className="fa fa-angle-double-left" aria-hidden="true"></i> {' '}Shapes</span> <span className="badge bg-dark text-white">=></span> 
                        <span className="badge medium p-2 bg-dark text-white">Select your shape</span> <span className="badge bg-dark text-white">=></span> 
                        <span className="badge medium p-2 bg-dark text-white"><i className="fa fa-angle-double-right" aria-hidden="true"></i></span> <span className="badge bg-dark text-white">=></span> 
                        <span className="badge medium p-2 bg-dark text-white">Shape editor</span> <span className="badge bg-dark text-white">=></span> 
                        <span className="badge medium p-2 bg-dark text-white">Number of elements</span> <span className="badge bg-info text-white">=></span> 
                        <span className="badge medium p-2 bg-info text-white">Inner and outer radius depending on the type <br/>
                        of shape</span> <span className="badge bg-warning text-dark">=></span> 
                        <span className="badge medium p-2 bg-warning text-dark">Choose the color of the shape</span> <span className="badge bg-info text-white">=></span> 
                        <span className="badge medium p-2 bg-dark text-white">Drag and drop the shape to change the position</span> <span className="badge bg-info text-white">=></span> 
                        <span className="badge medium p-2 bg-dark text-white">Click on {' '}<i
                className="fa fa-download large bg-dark text-white"
                aria-hidden="true"
              ></i>{' '}to download your pattern</span> <span className="badge bg-info text-white">=></span> 
                        <span className="badge medium p-2 bg-dark text-white">Do the same with the other shapes and download the result <br/>
                         by clicking on the download badge in the shape editor</span> <span className="badge bg-info text-white">=></span> 
                        <span className="badge medium p-2 bg-dark text-white">Currently the dpi is less than 150, we are working <br/> 
                        to put it a 300</span> <span className="badge bg-danger text-white">=></span> 
                        <span className="badge medium p-2 bg-danger text-white">Image are not recommanded for large printing format</span> <span className="badge bg-success text-white">=></span> 
                        <span className="badge medium p-2 bg-success text-white">Share the result with us</span> 
          <div>
                <br/>
                <br/>
                <br/>
          </div>
      </div>
      
    );
  }
}




export default Tutorial

